export default "__VITE_ASSET__CBKNI67v__"